.nav {
  position: sticky;
  top: 18px;
  z-index: 50;
  margin-top: 18px;
  padding: 0;
}

.nav-glow {
  position: absolute;
  left: 50%;
  top: -10px;
  width: 480px;
  max-width: 90vw;
  height: 120px;
  background: radial-gradient(60% 100% at 50% 0%, var(--color-accent-soft), transparent 70%);
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 500ms ease;
  pointer-events: none;
  z-index: -1;
  filter: blur(8px);
}

.nav-scrolled .nav-glow {
  opacity: 1;
}

.nav-inner {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-md);
  padding: 10px 14px 10px 18px;
  background: color-mix(in srgb, var(--color-bg) 72%, transparent);
  backdrop-filter: saturate(160%) blur(20px);
  -webkit-backdrop-filter: saturate(160%) blur(20px);
  border: 1px solid var(--color-border);
  border-radius: 999px;
  box-shadow:
    0 1px 0 color-mix(in srgb, white 6%, transparent) inset,
    0 1px 2px rgba(0, 0, 0, 0.04);
  transition:
    background 250ms ease,
    border-color 250ms ease,
    box-shadow 350ms ease,
    transform 250ms ease;
}

.nav-inner::before {
  content: "";
  position: absolute;
  inset: -1px;
  border-radius: inherit;
  padding: 1px;
  background: linear-gradient(
    120deg,
    color-mix(in srgb, var(--color-accent) 35%, transparent),
    transparent 35%,
    transparent 65%,
    color-mix(in srgb, var(--color-accent-2) 35%, transparent)
  );
  -webkit-mask:
    linear-gradient(#000 0 0) content-box,
    linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask:
    linear-gradient(#000 0 0) content-box,
    linear-gradient(#000 0 0);
  mask-composite: exclude;
  opacity: 0;
  transition: opacity 400ms ease;
  pointer-events: none;
}

.nav-scrolled .nav-inner {
  background: color-mix(in srgb, var(--color-bg) 88%, transparent);
  border-color: color-mix(in srgb, var(--color-border-strong) 80%, transparent);
  box-shadow:
    0 1px 0 color-mix(in srgb, white 8%, transparent) inset,
    0 8px 30px -8px rgba(0, 0, 0, 0.18),
    0 2px 6px rgba(0, 0, 0, 0.06);
}

.nav-scrolled .nav-inner::before {
  opacity: 1;
}

.nav-brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  font-size: 14px;
  color: var(--color-text);
  letter-spacing: -0.01em;
  padding: 4px 4px 4px 0;
  border-radius: 999px;
}

.nav-brand:hover {
  color: var(--color-text);
}

.nav-brand-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 6px;
  border-radius: 8px;
  background:
    radial-gradient(80% 80% at 30% 20%, color-mix(in srgb, var(--color-accent-soft) 60%, transparent), transparent 65%),
    var(--color-bg-muted);
  border: 1px solid var(--color-border);
  transition: transform 250ms ease, box-shadow 250ms ease;
}

.nav-brand:hover .nav-brand-mark {
  transform: translateY(-1px);
  box-shadow: 0 0 0 4px var(--color-accent-soft);
}

.nav-brand-text {
  font-family: var(--font-mono);
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.005em;
}

.nav-version {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 7px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-accent);
  background: var(--color-accent-soft);
  border: 1px solid color-mix(in srgb, var(--color-accent) 30%, transparent);
  border-radius: 999px;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: var(--color-text-muted);
}

.nav-links a:not(.nav-icon) {
  position: relative;
  padding: 7px 13px;
  border-radius: 999px;
  color: var(--color-text-muted);
  font-weight: 500;
  font-size: 13.5px;
  transition: color 150ms ease, background 150ms ease;
}

.nav-links a:not(.nav-icon):hover {
  color: var(--color-text);
  background: var(--color-bg-muted);
}

.nav-links a.active {
  color: var(--color-text);
}

.nav-links a.active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -3px;
  width: 14px;
  height: 2px;
  border-radius: 999px;
  background: var(--gradient-accent);
  transform: translateX(-50%);
  box-shadow: 0 0 8px var(--color-accent);
}

.nav-divider {
  width: 1px;
  height: 18px;
  margin: 0 6px;
  background: var(--color-border);
}

.nav-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  color: var(--color-text-muted) !important;
  transition: color 150ms ease, background 150ms ease;
}

.nav-icon:hover {
  color: var(--color-text) !important;
  background: var(--color-bg-muted);
}

@media (max-width: 820px) {
  .nav-brand-text {
    display: none;
  }
}

@media (max-width: 700px) {
  .nav {
    top: 12px;
    margin-top: 12px;
  }
  .nav-inner {
    padding: 8px 10px 8px 12px;
  }
  .nav-links a:not(.nav-icon) {
    display: none;
  }
  .nav-divider {
    display: none;
  }
}
